import { render, staticRenderFns } from "./DialogConsentIdUpdate.vue?vue&type=template&id=0ffda348&"
import script from "./DialogConsentIdUpdate.vue?vue&type=script&lang=js&"
export * from "./DialogConsentIdUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports